module.exports = __webpack_public_path__ + "static/media/generic-rss.876875ce.svg";